import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import { useParams } from "react-router-dom";
import { FETCH_PRODUCT_DETAIL } from "./All/graphql";
import ProductForm from "./All/ProductForm";
import ProductStatusChainView from "./components/ProductStatusChainView";

const ProductDetailPage = () => {
  const { id } = useParams();

  const { loading, error, data } = useQuery(FETCH_PRODUCT_DETAIL, {
    variables: { id },
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const product = data.product;

  return (
    <Page
      title={product.number}
      subtitle={product.name}
      className="lg:h-screen"
      backTo="./.."
    >
      <div className="p-6">
        <div>
          <ProductStatusChainView state={product.state} />
        </div>
        <div>
          <ProductForm />
        </div>
      </div>
    </Page>
  );
};

export default ProductDetailPage;
